import rentalTypesMixin from '@/mixins/rental-types'

export default {
  name: 'oz-accordion-rental-types',

  mixins: [rentalTypesMixin],
}
